import {GET_MarksTable, UPDATE_MARKS_TABLE} from '../constants/ActionTypes'

const INIT_STATE = {
    MarksTable: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_MarksTable:
            console.log(action, 'actionnnn');
            return {
                MarksTable: action.body,
                loading :false
            }
        // case UPDATE_MARKS_TABLE:
        //     console.log(action, 'aaaaccc');
        //     return {
        //         MarksTable: action.body
        //     }
        default:
            return state;
    }
}